import { map, reduce } from 'lodash';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import type { ICommission } from './Commission.interface';
import CommissionSplit from './CommissionSplit';

export default class Commission extends Root implements ICommission {
  name: string;
  splits: Array<CommissionSplit>;

  getName() {
    return this.name;
  }

  getTotalSplitUpfront() {
    return reduce(this.splits, (sum, n) => sum + n.getUpfront(), 0);
  }

  getTotalSplitUpfrontPercentage() {
    return reduce(this.splits, (sum, n) => sum + n.getUpfrontPercentage(), 0);
  }

  getTotalSplitTrail() {
    return reduce(this.splits, (sum, n) => sum + n.getTrail(), 0);
  }

  getTotalSplitTrailPercentage() {
    return reduce(this.splits, (sum, n) => sum + n.getTrailPercentage(), 0);
  }

  isUpfrontPercentageValid() {
    return this.getTotalSplitUpfrontPercentage() <= 100;
  }

  isTrailPercentageValid() {
    return this.getTotalSplitTrailPercentage() <= 100;
  }

  static build = (data: ICommission) => new Commission(data);
  static blank = () => new Commission({ isActive: true });

  /**
   * Constructor
   * @param {ICommission} data
   */
  constructor(data?: ICommission) {
    super(DocType.of('__definition.commission'), data);

    this.name = data?.name || '';
    this.splits = map(data?.splits, (obj) => new CommissionSplit(obj));
  }
}
